{
  "title": "Kotak masuk",
  "totalBadge": "{{count}} item",
  "viewAll": "Lihat semua",
  "loading": "Memuat…",
  "emptySection": "Semua sudah ditangani",
  "loadError": "Tidak dapat memuat bagian ini"
}
